export const FIRST_TWO_WEEKS_THRESHOLD = 14;

const INELIGIBLE = Object.freeze({ isEligible: false, loading: false } as const);
const LOADING = Object.freeze({ isEligible: false, loading: true } as const);

export type WelcomeFromRovoChatEligibility = {
	isEligible: boolean;
	loading: boolean;
};

export const getWelcomeFromRovoChatEligibility = ({
	isNewUser,
	isNewUserLoading,
	shouldSkipEligibilityCheck,
}: {
	isNewUser: boolean | null | undefined;
	isNewUserLoading?: boolean;
	shouldSkipEligibilityCheck: boolean;
}): WelcomeFromRovoChatEligibility => {
	if (shouldSkipEligibilityCheck) {
		return INELIGIBLE;
	}

	// Treat undefined loading as unresolved until useIsNewUser returns a definitive state.
	if (isNewUserLoading !== false) {
		return isNewUser === false ? INELIGIBLE : LOADING;
	}

	if (isNewUser !== true) {
		return INELIGIBLE;
	}

	return { isEligible: true, loading: false };
};
